import { userContext } from 'contexts/UserContext';
import { useContext } from 'react';
import { Modal } from 'antd';

import { Trans } from '@lingui/react/macro';
import { SUPPORT_LINKS } from 'config';

interface BYNotificationProps {
  onHide: () => void;
  visible: boolean;
}

export function BYNotification({ visible, onHide }: BYNotificationProps) {
  const { user } = useContext(userContext);
  const isBy = user.Groups.some((g) => g.Country === 'by');

  if (!isBy) return null;

  return (
    (<Modal
      open={visible}
      cancelButtonProps={{ hidden: true }}
      onOk={onHide}
      onCancel={onHide}
    >
      <Trans>
        Обращаем ваше внимание, что с 14.07.2026 для вендоров из Республики
        Беларусь техническая поддержка осуществляется ТОЛЬКО силами специалистов
        компании Живая Вода Россия. Телеграмм чат технической поддержки
        <a href={SUPPORT_LINKS.TG}>@alivewaternewbot</a>
      </Trans>
    </Modal>)
  );
}
